module.exports = __webpack_public_path__ + "static/media/betteraves.2c25090e.svg";